export default __webpack_public_path__ + "static/media/profile.7d7793a8.jpg";